import ClaimingProcess from 'screens/ClaimingProcess';
import CleaningReport from 'screens/CleaningReport';
import MyMachineDetails from 'screens/MyMachineDetails';
import MyMachines from 'screens/MyMachines';
import Notifications from 'screens/Notifications';
import Operators from 'screens/Operators';
import Overview from 'screens/Overview';
import AccountDeletedCallback from 'screens/AccountDeletedCallback';
import Callback from 'screens/Callback';
import EMRedirectPage from 'screens/EMRedirectPage';
import PrivacyPolicy from 'screens/PrivacyPolicy';
import DataProtection from 'screens/DataProtection';
import { routePaths } from './route-paths';

export const privateRoutes = [
  {
    path: routePaths.overview,
    component: Overview,
    exact: true
  },
  {
    path: routePaths.myMachine,
    component: MyMachines,
    exact: true
  },
  {
    path: routePaths.machineDetails,
    component: MyMachineDetails,
    exact: true
  },
  {
    path: routePaths.claimingProcess,
    component: ClaimingProcess,
    exact: true
  },
  {
    path: routePaths.cleaningReport,
    component: CleaningReport,
    exact: true
  },
  {
    path: routePaths.notifications,
    component: Notifications,
    exact: true
  },
  {
    path: routePaths.operators,
    component: Operators,
    exact: true
  },
  {
    path: routePaths.accountDeleted,
    component: AccountDeletedCallback,
    exact: true
  },
  {
    path: routePaths.dataProtection,
    component: DataProtection,
    exact: true
  }
];

export const publicRoutes = [
  {
    path: routePaths.callback,
    component: Callback,
    exact: true
  },
  {
    path: routePaths.privacyPolicy,
    component: PrivacyPolicy,
    exact: true
  },
  {
    path: routePaths.emRedirectPage,
    component: EMRedirectPage,
    exact: true
  }
];
